import API from "./index";

export const authmonitor = (data: any) => API.handleApiRequest(() => API.post(`auditor/authmonitor`, data));
export const reloginAPI = (data: any) => API.handleApiRequest(() => API.post(`auditor/reAuthenticate`, data));
export const refreshToken = (data: any) => API.handleApiRequest(() => API.post(`auditor/refreshToken`, data));